// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-btn[data-v-1c973810]{background-color:var(--portalCardBtn);color:#fff;padding:8px;border-radius:15px;cursor:pointer}.card-btn[data-v-1c973810]:hover{background-color:var(--portalCardBtnHover)}.card-btn-title[data-v-1c973810]{text-align:center}", ""]);
// Exports
module.exports = exports;
